import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface Tab {
  id: string;
  label: string;
  count?: number;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}
export function Tabs({
  tabs,
  activeTab,
  onTabChange,
  className = ''
}: TabsProps) {
  return <div className={`flex gap-1 bg-[#141414] p-1 rounded-lg overflow-x-auto ${className}`} role="tablist" data-id="element-635">
      {tabs.map(tab => <button key={tab.id} role="tab" aria-selected={activeTab === tab.id} onClick={() => onTabChange(tab.id)} className={`relative px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap transition-colors duration-200 ${activeTab === tab.id ? 'text-[#0D0D0D]' : 'text-[#B0B0B0] hover:text-white'}`} data-id="element-636">
          {activeTab === tab.id && <motion.div layoutId="activeTab" className="absolute inset-0 bg-[#C8A84E] rounded-md" transition={{
        type: 'spring',
        bounce: 0.15,
        duration: 0.4
      }} data-id="element-637" />}
          <span className="relative z-10 flex items-center gap-1.5" data-id="element-638">
            {tab.label}
            {tab.count !== undefined && <span className={`text-xs px-1.5 py-0.5 rounded-full ${activeTab === tab.id ? 'bg-[#0D0D0D]/20 text-[#0D0D0D]' : 'bg-[#2A2A2A] text-[#666666]'}`} data-id="element-639">
                {tab.count}
              </span>}
          </span>
        </button>)}
    </div>;
}